<modal class="scoring-container">
    @for (message of messages; track message) {
        <p class="has-text-centered" [innerHTML]="message"></p>
    }

    @if (showPayment) {
        <div>
            <span>
                Si vous décidez de continuer avec le paiement en une fois, les montants de votre facture seront modifiés
                de la manière suivante :
            </span>
            <checkout-ticket [noButtons]="true"></checkout-ticket>
        </div>
    }

    <ng-template #customModalFooter>
        <div class="buttons">
            <button class="button is-secondary" (click)="errorRedirect()">Revenir à l'accueil</button>
            @if (showPayment) {
                <button class="button is-conversion" (click)="payWithCash()">Payer en une fois</button>
            } @else if (showUnpaid) {
                <button class="button is-conversion" (click)="redirectToAccount()">Régulariser mon impayé</button>
            } @else {
                <button class="button is-conversion" (click)="redirectToStore()">Trouver une boutique</button>
            }
        </div>
    </ng-template>
</modal>
